// @ vendors
const { Promise } = require('es6-promise');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');

const deleteFilesMortgageDenialInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_DELETE_MORTGAGEDENIAL_REQUEST
});

const deleteFilesMortgageDenialSuccess = (data) => ({
    type: actionTypes.MORTGAGE_REQUEST_DELETE_MORTGAGEDENIAL_SUCCESS,
    data: data
});

const deleteFilesMortgageDenialFailure = (error) => ({
    type: actionTypes.MORTGAGE_REQUEST_DELETE_MORTGAGEDENIAL_FAILURE,
    data: {
        error
    }
});

const deleteFilesMortgageDenial = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestMortgageDenial;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        const url = apiURLBuilder.getURL('mortgageRequestMortgageDenialDelete');

        dispatch(deleteFilesMortgageDenialInProgress());

        return APIPost({
            dispatch,
            endpoint: 'mortgageRequestMortgageDenialDelete',
            url: `${url}`
        })
        .then(response => dispatch(deleteFilesMortgageDenialSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(deleteFilesMortgageDenialFailure(response.error))
            } else {
                throw response;
            }
        });
    } else {
        return Promise.resolve()
    }
};

module.exports = {
    deleteFilesMortgageDenial
};
